import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  mainTable: {
    width: '100%',
    height: '650px',
  },
}))
